// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/**
 * TODO:Remove these lint disable rules -
 * need them as on autosave optional chaining and things break
 * https://lastbrand.atlassian.net/browse/SFPLTFRM-849
 *  */
import { CardVariant, IWebsiteProduct } from '@src/components/product-card/product-card.types'
import {
  getIndividualTagStatus,
  getUrgencyTagsInventoryForTracking,
  ProductTagKey,
} from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'

export interface ProductProperties {
  product_id: string
  title: string
  color?: string
  count_color_variant: number
  rating: string
  tags: string[]
  review_count: number
  oos_flag: number
  division: string
  division_id: string
  department: string
  department_id: string
  subdepartment: string
  subdepartment_id: string
}

export const getProductPropertiesForTracking = (product: Product | Bundle, variantId?: string): ProductProperties => {
  let variant = undefined

  if (variantId) {
    variant = (product as Product)?.variants.find(vr => vr.shopifyVariantId?.toString() === variantId.toString())
  }

  const productColorOption = product.productOptions.find(po => po.name.toLowerCase() === 'color') ?? undefined
  const firstProductColorOptionValue = productColorOption?.values?.[0]
  const selectedColorOptionValue =
    variantId && variant
      ? (variant.options.find(opt => opt.name.toLowerCase() === 'color') ?? undefined)
      : firstProductColorOptionValue
  const division = product.classification?.division
  const department = product.classification?.department
  const subDepartment = product.classification?.subDepartment
  const productTagsForSelectedColor: string[] = []
  product.tags.forEach(tg => {
    const isTagForColor = tg.options.some(
      tgOpt => tgOpt.value.toLowerCase() === selectedColorOptionValue?.value.toLowerCase(),
    )
    if (isTagForColor) {
      productTagsForSelectedColor.push(tg.value)
    }
  })

  return {
    product_id: product?.shopifyProductId?.toString(),
    title: product.title,
    color: selectedColorOptionValue?.value,
    count_color_variant: productColorOption?.values?.length ?? 0,
    rating: product.productReviewSummary?.averageRating?.toString() ?? '',
    tags: productTagsForSelectedColor,
    review_count: product.productReviewSummary?.reviewCount ?? 0,
    oos_flag: getIndividualTagStatus(productTagsForSelectedColor as ProductTagKey[]).sold_out,
    division: division?.name ?? '',
    division_id: division?.id?.toString() ?? '',
    department: department?.name ?? '',
    department_id: department?.id?.toString() ?? '',
    subdepartment: subDepartment?.name ?? '',
    subdepartment_id: subDepartment?.id?.toString() ?? '',
  }
}

export const getProductPropertiesForTrackingForCard = (
  product: IWebsiteProduct,
  tags: string[],
  selectedVariant?: CardVariant,
): ProductProperties => {
  return {
    product_id: product.productId.toString(),
    title: product.title,
    color: selectedVariant?.displayConfig.displayName,
    count_color_variant: product.colorVariants?.length ?? 0,
    rating: product.reviews.averageRating.toString(),
    tags,
    review_count: product.reviews.reviewCount,
    oos_flag: selectedVariant?.tags.some(({ value }) => value === 'Sold Out') ? 1 : 0,
    division: product.classification?.division ?? '',
    division_id: product.classification?.division_id.toString() ?? '',
    department: product.classification?.department ?? '',
    department_id: product.classification?.department_id.toString() ?? '',
    subdepartment: product.classification?.subdepartment ?? '',
    subdepartment_id: product.classification?.subdepartment_id.toString() ?? '',
    ...getUrgencyTagsInventoryForTracking(selectedVariant),
  }
}

export const getProductPropertiesForTrackingNew = ({
  product,
  productVariant,
  tags,
}: {
  product: IWebsiteProduct
  productVariant?: CardVariant
  tags: string[]
}): ProductProperties => {
  return {
    product_id: product?.relatedIds.shopifyId?.toString(),
    title: product.title,
    color: productVariant?.displayConfig.value,
    count_color_variant: product?.colorVariants?.length ?? 0,
    rating: product?.reviews?.averageRating?.toString() ?? '',
    tags: tags,
    review_count: product?.reviews?.reviewCount ?? 0,
    oos_flag: getIndividualTagStatus(tags as ProductTagKey[]).sold_out,
    division: product?.classification?.division ?? '',
    division_id: product?.classification?.division_id?.toString() ?? '',
    department: product?.classification?.department ?? '',
    department_id: product?.classification?.department_id?.toString() ?? '',
    subdepartment: product?.classification?.subdepartment ?? '',
    subdepartment_id: product?.classification?.subdepartment_id?.toString() ?? '',
    ...getUrgencyTagsInventoryForTracking(productVariant),
  }
}
